import { Steps as Stepss } from 'primereact/steps';  

const Steps = ({...rest}) => {

    return (
        <Stepss {...rest} />
    )

};

export default Steps;